// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__sFs18","rotate":"style_rotate__H9cOY","path":"style_path__Oox7O","dash":"style_dash__lUR2A"};